export const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{6,64}$/;
export const REFERRAL_REWARD_PERCENT = 10;
export const REFERRAL_MAX_DISCOUNT_PERCENT = 50;
export const REFERRAL_GRANT_NOTE_MAX_LENGTH = 200;
